import { Badge } from "../../../../../shared/components/badge/Badge";
import { useTranslation } from "react-i18next";

const TacticLineOverwrittenBadge = ({ isOverwritten }) => {
  const { t } = useTranslation();

  return isOverwritten ? (
    <Badge variant="secondary">{t("defaults.overriden")}</Badge>
  ) : (
    <></>
  );
};

export default TacticLineOverwrittenBadge;
